import { User } from './auth.types'

export const userMock: User = {
  id: '',
  companyName: 'Demo Company',
  streetNumber: '123',
  streetName: 'Main St',
  unitNumber: '1A',
  city: 'Metropolis',
  state: 'CA',
  zipCode: '12345',
  country: 'USA',
  email: '',
  taxNumber: 'TAX123456',
  taxPercentage: 10,
  orderStartNumber: 1000,
  tripPrefix: 'TRIP',
  tripStartNumber: 500,
  invoicePrefix: 'INVC',
  invoiceStartNumber: 0,
  orderPrefix: 'ORD',
  deletedAt: '',
  createdAt: new Date().toISOString(),
  modifiedAt: new Date().toISOString(),
  outMail: '',
  verified: true,
  otp: 123456,
}
